// extracted by mini-css-extract-plugin
export var box = "SocialButtons-module--box--3cb12";
export var box_md = "SocialButtons-module--box_md--840c7";
export var box_xmd = "SocialButtons-module--box_xmd--de993";
export var box_flex = "SocialButtons-module--box_flex--3215c";
export var box_lg = "SocialButtons-module--box_lg--da293";
export var box_sm = "SocialButtons-module--box_sm--b6b2c";
export var box_outer = "SocialButtons-module--box_outer--20d8e";
export var box_whiteBg = "SocialButtons-module--box_white-bg--26315";
export var box_noMarginBottom = "SocialButtons-module--box_no-margin-bottom--00f0a";
export var box_noPadding = "SocialButtons-module--box_no-padding--76255";
export var box_outerGray = "SocialButtons-module--box_outer-gray--20530";
export var box_dark = "SocialButtons-module--box_dark--d2b46";
export var box_zIndex = "SocialButtons-module--box_z-index--03529";
export var box_zIndex6 = "SocialButtons-module--box_z-index-6--a6346";
export var box_eventsWithLine = "SocialButtons-module--box_events-with-line--bb749";
export var box_featuresAo = "SocialButtons-module--box_features-ao--dd849";
export var box_verticalPaddings = "SocialButtons-module--box_vertical-paddings--e2225";
export var clearP = "SocialButtons-module--clearP--02d62";
export var clearP_vc = "SocialButtons-module--clearP_vc--06fc6";
export var link = "SocialButtons-module--link--2fc4d";
export var icon = "SocialButtons-module--icon--68d26";
export var fadeInAnimation = "SocialButtons-module--fadeInAnimation--fdca4";
export var placeHolderShimmer = "SocialButtons-module--placeHolderShimmer--3aa75";